import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material'
import React from 'react'

export enum WalletProviders {
  Argent = 'Argnet',
  Atomic = 'Atomic',
  Authereum = 'Authereum',
  Bread = 'Bread',
  Cipher = 'Cipher',
  Coinbase = 'Coinbase',
  Coinomi = 'Coinomi',
  Dharma = 'Dharma',
  Edge = 'Edge',
  Enjin = 'Enjin',
  Etherwall = 'Etherwall',
  Exodus = 'Exodus',
  Fortmatic = 'Fortmatic',
  Free = 'Free',
  Guarda = 'Guarda',
  Jaxx = 'Jaxx',
  KeepKey = 'KeepKey',
  Ledger = 'Ledger',
  Lumi = 'Lumi',
  MetaMask = 'MetaMask',
  Mist = 'Mist',
  MyCrypto = 'MyCrypto',
  MyEtherWallet = 'MyEtherWallet',
  Opera = 'Opera',
  Status = 'Status',
  Torus = 'Torus',
  Toshi = 'Toshi',
  Trezor = 'Trezor',
  Trust = 'Trust',
  imToken = 'imToken',
}

interface ConnectWalletDialogProps {
  onClose?: (provider?: WalletProviders) => void
  open?: boolean
}

const ConnectWalletDialogOpen: React.FC<ConnectWalletDialogProps> = (props) => {
  const { open = true, onClose } = props

  return (
    <Dialog onClose={() => onClose?.()} open={open}>
      <DialogTitle>Connect Wallet</DialogTitle>
      <DialogContent>
        <Box display="flex" flexDirection="column">
          <Box display="flex" width="100%">
            <Typography variant="body1">To access XYO World, please conect a wallet.</Typography>
          </Box>
          <Button onClick={() => onClose?.(WalletProviders.MetaMask)} variant="outlined">
            MetaMask
          </Button>
          <Button onClick={() => onClose?.(WalletProviders.Trust)} variant="outlined">
            Trust
          </Button>
          <Button onClick={() => onClose?.(WalletProviders.Fortmatic)} variant="outlined">
            Fortmatic
          </Button>
        </Box>
      </DialogContent>
      <DialogActions>
        <Box display="flex" width="100%">
          <Box flexGrow={1}></Box>
          <Box>
            <Button onClick={() => onClose?.()} variant="text">
              Close
            </Button>
          </Box>
        </Box>
      </DialogActions>
    </Dialog>
  )
}

const ConnectWalletDialog: React.FC<ConnectWalletDialogProps> = (props) => {
  const { open } = props
  if (open) {
    return <ConnectWalletDialogOpen {...props} />
  } else {
    return null
  }
}

export default ConnectWalletDialog
